import { useCanInviteOrganizationMembers } from '#pplx/frontend/apps/ask/organization/hooks/useCanInviteOrganizationMembers.js';
import { useIsEnterpriseUser } from '#pplx/frontend/auth/useIsEnterpriseUser.js';
import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
export function getSidebarInviteKind({ canInviteMembers, isEnterpriseUser, isPro, }) {
    if (isEnterpriseUser)
        return canInviteMembers ? 'org-members' : null;
    return isPro ? 'team-upsell' : null;
}
export function useSidebarInviteKind() {
    const isEnterpriseUser = useIsEnterpriseUser();
    const { isPro } = useIsSubscribed();
    const { canInviteMembers } = useCanInviteOrganizationMembers();
    return getSidebarInviteKind({ canInviteMembers, isEnterpriseUser, isPro });
}
//# sourceMappingURL=useSidebarInviteKind.js.map